export default __webpack_public_path__ + "static/media/logo-favicon.e272a444.svg";